import React from 'react';
import { Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import Select from 'react-select';
import { getRequestOptions } from "../helpers/Fetchwrapper";
import { Card } from 'react-bootstrap-v5';
import 'react-toastify/dist/ReactToastify.css';
import { numberFormat } from '../helpers/GlobalHelper';
import DataTable from '../components/DataTable';
import { KTSVG } from '../../_metronic/helpers'
import { useLocation, Link } from "react-router-dom";


const DetailPurchaseItemSearch: React.FC = () => {

    const location = useLocation();
    const query = new URLSearchParams(location.search);

    const [formData, setFormData] = useState({
        idProjects: query.get('idProjects') ?? '',
        fromDate: '',
        toDate: '',
        idItems: query.get('idItems') ?? '',
    });

    const [filterColumns, setFilterColumns] = useState({
        idProjects: query.get('idProjects') ?? '',
        fromDate: '',
        toDate: '',
        idItems: query.get('idItems') ?? '',
        order: 'DESC',
        sortedColumn: 'id',
    });

    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });

    useEffect(() => {
        getProjects();
    }, []);


    useEffect(() => {
        if (projects.length > 0) {
            setProject(projects[0]);
            setFormData((prevFormData) => ({
                ...prevFormData,
                idProjects: projects[0].value,
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projects]);
    
    const jwt = () => {
		const myToken = localStorage.getItem('MyToken');
		return (myToken != null) ? JSON.parse(myToken) : null;
	}


    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => ({
                    label: item.name,
                    value: item.id,
                }));
                setProjects(projectObj);
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
            });
    };

    const handleProjectChange = (project: any) => {
        setProject(project);
        setFormData({ ...formData, idProjects: project ? project.value : '' });
        setFilterColumns({ ...filterColumns, idProjects: project ? project.value : '' });
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
        setFilterColumns({ ...filterColumns, [name]: value });
    };

    

    const columns = [
        { value: 'id', title: 'ID', style: { textAlign: 'center' } },
        { value: 'projectName', title: 'Project', style: { textAlign: 'left' } },
        { value: 'purchaseType', title: 'Type', style: { textAlign: 'left' } },
        { value: 'purpose', title: 'Purpose', style: { textAlign: 'left' } },
        { value: 'referenceNo', title: 'PO No', style: { textAlign: 'left' } },
        { value: 'lcNo', title: 'LC No', style: { textAlign: 'left' } },
        { value: 'vendorName', title: 'Vendor', style: { textAlign: 'left' } },
        { value: 'purchaseDate', title: 'Purchase Date', style: { textAlign: 'left' } },
        { value: 'itemName', title: 'Item Name', style: { textAlign: 'left' } },
        { value: 'itemCode', title: 'Item Code', style: { textAlign: 'left' } },
        { value: 'categoryName', title: 'Item Category', style: { textAlign: 'left' } },
        {
            value: 'quantity', title: 'Purchase Quantity', style: { textAlign: 'center' },
            hasHtmlComponent: true,
            htmlComponent: (row: any) => {
                return (
                    <>
                        {numberFormat(row.quantity)}
                    </>
                )
            },
        },
        {
            value: 'receiveQty', title: 'Received Qty', style: { textAlign: 'center' },
            hasHtmlComponent: true,
            htmlComponent: (row: any) => {
                return (
                    <>
                        {numberFormat(row.receiveQty)}
                    </>
                )
            },
        },
        { value: 'unitName', title: 'Unit', style: { textAlign: 'left' } },
        {
            value: 'excludingRate', title: 'Rate', style: { textAlign: 'center' },
            hasHtmlComponent: true,
            htmlComponent: (row: any) => {
                return (
                    <>
                        {numberFormat(row.excludingRate)}
                    </>
                )
            },
        },
        {
            value: 'action', title: 'Amount', style: { textAlign: 'center' },
            hasHtmlComponent: true,
            htmlComponent: (row: any) => {
                return (
                    <>
                        {numberFormat(row.quantity*row.excludingRate)}
                    </>
                )
            },
        },
        { value: 'discountAmount', title: 'Discount Amount', style: { textAlign: 'left' } },
        { value: 'carryingCost', title: 'Carrying Cost', style: { textAlign: 'left' } },
        {
            value: 'action', title: 'Total Amount', style: { textAlign: 'center' },
            hasHtmlComponent: true,
            htmlComponent: (row: any) => {
                return (
                    <>
                        {numberFormat(row.quantity*row.excludingRate-Number(row.discountAmount) + Number(row.carryingCost))}
                    </>
                )
            },
        },
        { value: 'rate', title: 'Rate Including', style: { textAlign: 'left' } },
        { value: 'createdBy', title: 'Created By', style: { textAlign: 'left' } },
        {
            value: 'action', title: 'Action', style: { textAlign: 'left', whiteSpace: 'nowrap' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
                return (
                    <>
                        <Link className="btn btn-light-primary btn-sm px-2 py-1" to={`/po-details/${row.idPo}`}>
                            <KTSVG
                                path='/media/svg/icons/Layout/Layout-grid.svg'
                                className='svg-icon-5 svg-icon'
                            />		Details
                        </Link>
                       
                    </>
                )
            })
        }
    ]

    const filters = {
        id: {
            filterType: 'like',
            filterValue: '',
        },
        projectName: {
            filterType: 'like',
            filterValue: '',
        },
        purchaseType: {
            filterType: 'like',
            filterValue: '',
        },
        purpose: {
            filterType: 'like',
            filterValue: '',
        },
        referenceNo: {
            filterType: 'like',
            filterValue: '',
        },
        lcNo: {
            filterType: 'like',
            filterValue: '',
        },
        vendorName: {
            filterType: 'like',
            filterValue: '',
        },
        purchaseDate: {
            filterType: 'like',
            filterValue: '',
        },
        itemName: {
            filterType: 'like',
            filterValue: '',
        },
        itemCode: {
            filterType: 'like',
            filterValue: '',
        },
        categoryName: {
            filterType: 'like',
            filterValue: '',
        },
        quantity: {
            filterType: 'like',
            filterValue: '',
        },
        receiveQty: {
            filterType: 'like',
            filterValue: '',
        },
        unitName: {
            filterType: 'like',
            filterValue: '',
        },
        excludingRate: {
            filterType: 'like',
            filterValue: '',
        },
        amount: {
            filterType: 'like',
            filterValue: '',
        },
        discountAmount: {
            filterType: 'like',
            filterValue: '',
        },
        carryingCost: {
            filterType: 'like',
            filterValue: '',
        },
        total: {
            filterType: 'like',
            filterValue: '',
        },
        rate: {
            filterType: 'like',
            filterValue: '',
        },
        createdBy: {
            filterType: 'like',
            filterValue: '',
        },
    }

    const url = process.env.REACT_APP_API_URL + 'reports/purchase/search'

    const additionalPostData = {
		idProjects: project.value,
        fromDate: formData.fromDate,
		toDate: formData.toDate,
        idItems: formData.idItems,

	};

    
    const getFilterParams =(data:any)=>{
       
        // Create an updated filterColumns object
        const updatedColumns: Record<string, any> = {};
    
        // Iterate through each column in the data.columns object
        Object.keys(data.columns).forEach((columnKey: string) => {
            const column = data.columns[columnKey];
            updatedColumns[columnKey] = column.filterValue || ''; // Default to empty string if filterValue is undefined
        });

        setFilterColumns({
            ...filterColumns, // Include the existing column filters
            ...updatedColumns, // Include the new column filters
            order: data.order || 'DESC',
            sortedColumn: data.sorted_column || 'id',
            globalSearch: data.globalSearch || '',
            token: data.token || '',
        });

    }

    const queryParams = new URLSearchParams(Object.entries(formData));

    
    return (
        <>
            <Card className='mb-4'>
                <Card.Body>
                    <Card.Text>
                        <div className='row'>
                            <div className='col-md-3'>
                                <Form.Group className="mb-3" controlId="project">
                                    <Form.Label>Project<span className='required'></span></Form.Label>
                                    <Select
                                        value={project}
                                        onChange={handleProjectChange}
                                        options={projects}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        isClearable={true}
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3">
                                    <Form.Label>From Date<span className='required'></span></Form.Label>
                                    <Form.Control type="date" placeholder="From Date" name='fromDate' onChange={handleChange} />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3">
                                    <Form.Label>To Date<span className='required'></span></Form.Label>
                                    <Form.Control type="date" placeholder="To Date" name='toDate' onChange={handleChange} />
                                </Form.Group>
                            </div>
                            <div className='col-md-3'>
                                <div className="form-control-sm ps-0 mt-7">
                                    <a className="btn btn-sm btn-primary p-3 ms-3" href={`${process.env.REACT_APP_BACKEND}detail_purchase_item_search_report_download?${queryParams.toString()}&token=`+jwt()}><i className='fas fa-download'></i> Excel Download</a>
                                </div>
                            </div>
                        </div>
                    </Card.Text>
                </Card.Body>
            </Card>

            <div className='row'>
                <div className='col-12'>
                    <DataTable url={url} columns={columns} filters={filters} additionalPostData={additionalPostData} onValueChange={(state:any) => {
                        getFilterParams(state);
                    }}/>
                </div>
            </div>
        </>
    );
};

export default DetailPurchaseItemSearch;